import { render, staticRenderFns } from "./copyParent.vue?vue&type=template&id=67c63378&scoped=true&"
import script from "./copyParent.vue?vue&type=script&lang=js&"
export * from "./copyParent.vue?vue&type=script&lang=js&"
import style0 from "./copyParent.vue?vue&type=style&index=0&id=67c63378&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c63378",
  null
  
)

export default component.exports